import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * A reusable empty content placeholder component
 * Used across split-view components when no content is available
 */
const EmptyContentPlaceholder = ({
  title,
  description,
  examplePrompt,
  additionalInfo
}) => {
  return (
    <Box sx={{ p: 3, textAlign: 'center', backgroundColor: '#f9f9f9', borderRadius: 1, mb: 2 }}>
      <Typography color="text.secondary" variant="subtitle1" fontWeight={500} gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {description}
      </Typography>
      {examplePrompt && (
        <Box sx={{ backgroundColor: 'rgba(25, 118, 210, 0.05)', p: 2, borderRadius: 1, mb: 2 }}>
          <Typography variant="body2" color="primary.main" fontStyle="italic">
            {examplePrompt}
          </Typography>
        </Box>
      )}
      {additionalInfo && (
        <Typography variant="body2" color="text.secondary">
          {additionalInfo}
        </Typography>
      )}
    </Box>
  );
};

export default EmptyContentPlaceholder;